// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.meter {
  height: 20px;
  position: relative;
  background: rgb(243, 239, 239);
  border-radius: 25px;
}

.meter > span {
  display: block;
  height: 100%;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  background-color: #aaa5ff;
  position: relative;
  overflow: hidden;
}

.skill {
  line-height: 3.5vw;
}

.skill-bars {
  font-size: 28px;
  width: 40%;
}

.skills-container {
  display: flex;
  width: 90%;
  padding: 20px 10px;
  margin: 0px auto;
  margin-top: 2rem;
}

.skills-container > * {
  flex: 1 1;
  margin-bottom: 30px;
}

.skills-image > img {
  margin-left: 80px;
  max-width: 90%;
  height: auto;
}

/* Media Query */
@media (max-width: 1456px) {
  .skills-bar {
    line-height: 4rem;
  }
  .skills-image {
    display: none;
    order: 2;
  }
}
@media (max-width: 768px) {
  .skills-container {
    flex-direction: column;
  }
  .skills-bar {
    line-height: 3rem;
    margin: 20px;
  }
  .skills-image {
    display: none;
    order: 2;
  }
}`, "",{"version":3,"sources":["webpack://./src/_globalColor.scss","webpack://./src/containers/skillProgress/Progress.scss"],"names":[],"mappings":"AAAA;;mEAAA;ACEA;EACE,YAAA;EACA,kBAAA;EACA,8BDuDsB;ECpDtB,mBAAA;AAEF;;AAAA;EACE,cAAA;EACA,YAAA;EACA,4BAAA;EACA,+BAAA;EACA,4BAAA;EACA,+BAAA;EACA,yBDsDkB;ECrDlB,kBAAA;EACA,gBAAA;AAGF;;AADA;EACE,kBAAA;AAIF;;AAFA;EACE,eAAA;EACA,UAAA;AAKF;;AAHA;EACE,aAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAMF;;AAJA;EACE,SAAA;EACA,mBAAA;AAOF;;AALA;EACE,iBAAA;EACA,cAAA;EACA,YAAA;AAQF;;AALA,gBAAA;AAEA;EACE;IACE,iBAAA;EAOF;EALA;IACE,aAAA;IACA,QAAA;EAOF;AACF;AAJA;EACE;IACE,sBAAA;EAMF;EAJA;IACE,iBAAA;IACA,YAAA;EAMF;EAJA;IACE,aAAA;IACA,QAAA;EAMF;AACF","sourcesContent":["/* Change colors in this file to style to your needs on a global level. \nCertain colors are used for different and multiply types of elements. \nFor greater control over colors visit each components .scss file. */\n\n// button colors\n$buttonColor: #55198b;\n$buttonHover: #8c43ce;\n$topButtonHover: #000;\n\n// text colors light theme\n$titleColor: #000000;\n$textColor: #000000;\n$subTitle: #868e96;\n$cardSubtitle: #666666;\n$talkCardSubTitle: #7f8287;\n$blogCardTitleColor: #262626;\n\n// text color dark theme\n$textColorDark: #ffffff;\n\n// toggle switch colors\n$toggleCheck: #2196f3;\n$toggleSwitchSliderBG: #ccc;\n\n// githubRepo specific colors\n$githubRepoCardLanguageColorBG: #0000ff;\n$githubRepoCardColor: rgb(88, 96, 105);\n$githubRepoCardRepoCardStatsColor: rgb(106, 115, 125);\n$githubRepoCardRepoNameColor: rgb(36, 41, 46);\n$githubProfileCardLocationTS: #ffebcd;\n$githubProfileCardBorder: #6c63ff;\n\n// light background colors\n$lightBackground1: #fff;\n$lightBackground2: rgb(255, 255, 255);\n$lightBackground3: #f5f2f4;\n$blogCardContainerColor: #586069;\n// dark background colors\n$darkBackground: #171c28;\n\n// light theme box shadows\n$lightBoxShadowDark: rgba(0, 0, 0, 0.2);\n$lightBoxShadow: rgba(0, 0, 0, 0.1);\n$lightBoxShadowDarker: rgba(0, 0, 0, 0.3);\n\n// dark theme box shadows\n$darkBoxShadow: #d9dbdf;\n$darkBoxShadow2: #ffffff;\n\n// linear gradients\n$experienceCardBlurredDivLG: linear-gradient(\n  rgba(0, 0, 0, 0.4),\n  rgba(0, 0, 0, 0.2)\n);\n$experienceCardBannerLG: linear-gradient(\n  rgba(0, 0, 0, 0.7),\n  rgba(0, 0, 0, 0.5)\n);\n\n// borders\n$progressBarBackground: rgb(243, 239, 239);\n$lightBorder1: rgba(211, 211, 211, 0.397);\n$educationCardBorder: #a9a7f9;\n\n// hovers\n$achievementCertificateCardHoverDark: rgba(255, 255, 255, 0.2);\n$blogCardHoverSmallColor: rgba(255, 255, 255, 0.8);\n$headerHoverBG: #f4f4f4;\n$contactDetailHoverTS: #b5b5b5;\n\n// misc backgrounds\n$progressBarSpanBG: #aaa5ff;\n$iconBackground: #333;\n$appHeaderBG: #282c34;\n\n// misc colors\n$skillsColor: #645beb;\n$appLink: #09d3ac;\n\n// social media icons\n$faceBook: #3b5998;\n$linkedin: #0e76a8;\n$github: #333;\n$gitlab: #fca326;\n$google: #ea4335;\n$twitter: #1da1f2;\n$medium: #000;\n$stackoverflow: #f48024;\n$instagram: #c13584;\n$kaggle: #20beff;\n","@import \"../../_globalColor\";\n\n.meter {\n  height: 20px;\n  position: relative;\n  background: $progressBarBackground;\n  -moz-border-radius: 25px;\n  -webkit-border-radius: 25px;\n  border-radius: 25px;\n}\n.meter > span {\n  display: block;\n  height: 100%;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n  border-top-left-radius: 20px;\n  border-bottom-left-radius: 20px;\n  background-color: $progressBarSpanBG;\n  position: relative;\n  overflow: hidden;\n}\n.skill {\n  line-height: 3.5vw;\n}\n.skill-bars {\n  font-size: 28px;\n  width: 40%;\n}\n.skills-container {\n  display: flex;\n  width: 90%;\n  padding: 20px 10px;\n  margin: 0px auto;\n  margin-top: 2rem;\n}\n.skills-container > * {\n  flex: 1;\n  margin-bottom: 30px;\n}\n.skills-image > img {\n  margin-left: 80px;\n  max-width: 90%;\n  height: auto;\n}\n\n/* Media Query */\n\n@media (max-width: 1456px) {\n  .skills-bar {\n    line-height: 4rem;\n  }\n  .skills-image {\n    display: none;\n    order: 2;\n  }\n}\n\n@media (max-width: 768px) {\n  .skills-container {\n    flex-direction: column;\n  }\n  .skills-bar {\n    line-height: 3rem;\n    margin: 20px;\n  }\n  .skills-image {\n    display: none;\n    order: 2;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
